export default {
  mainNavBar: {
    aboutUs: 'About us',
    introduction: 'Bemutatkozás',
    services: 'Szolgáltatások',
    career: 'Karrier',
    workSheets: 'Munkalapjaim',
    partners: 'Partnerek',
    contact: 'Kapcsolat',
    generalInformations: 'Általános információk',
    jobOffers: 'Állásajánlatok',
    stores: 'Üzletek',
    home: 'Kezdőlap',
    mwc: 'MWC',
    sales: 'Akciók',
    products: 'Termékek',
    catalog: 'Katalógus',
    faq: 'FAQ',
    howItWorks: 'How it works?',
    promoPlaces: 'Details of the promotion',
  },
  covid: 'Covid-19',
  mobilfutar: 'Mobilfutár',
  warrantyRepairForm: 'Garanciális javítási igény leadás',
  insuranceRepairForm: 'Biztosítási javítási igény leadás',
  introduction: 'Bemutatkozás',
  ourServices: 'Szolgáltatásaink',
  whyChooseUs: 'Miért válassz minket?',
  ourPartners: 'Partnereink',
  generalRequirements: 'Általános elvárásaink',
  seeJobOffers: 'Tekintse meg aktuális állásajánlatainkat',
  complexServiceForOurPartners: 'Komplex szolgáltatás partnereink részére',
  centralEuropeSuperGrowingService: 'Közép-Európa dinamikusan fejlődő szervize',
  whereCanYouFindUs: 'Merre talál minket?',
  sendUsAMessage: 'Küldjön nekünk üzenetet!',
  ourEmail: 'Our e-mail',
  ourPhoneNumber: 'Our phone number',
  ourStores: 'Üzleteink',
  serviceProducts: 'Szervizelt termékek',
  impress: 'Imprint',
  nameOfTheCompany: 'A Vállalkozás neve',
  headquarter: 'Székhely',
  headquarterOfTheCompany: 'A Vállalkozás székhelye',
  sitesOfTheCompany: 'A Vállalkozás fióktelepei',
  postalAddressOfTheCompany: 'A Vállalkozás postai címe',
  phoneNumberOfTheCompany: 'A Vállalkozás telefonszáma',
  telefaxNumberOfTheCompany: 'A Vállalkozás telefax száma',
  emailOfTheCompany: 'A Vállalkozás elektronikus levelezési címe',
  VATNumberOfTheCompany: 'A Vállalkozás közösségiadószáma',
  webhostDetails: 'A Weboldal tárhelyszolgáltatójának neve és adatai',
  complaintPolicy: 'Complaints handling policy',
  privacyPolicy: 'Privacy Policy',
  termsAndCond: 'General Terms and Conditions',
  usedEquipmentForSale: 'Használt készülékek adásvétele - ÁSZF',
  cookies: 'Cookies',
  mwcDate: '2020. február 24-27.',
  button: {
    view: 'View',
    findOutMore: 'Find out more',
    confirmAppointment: 'Időpont lefoglalása',
    back: 'Back',
    cancel: 'Cancel',
    next: 'Next',
    send: 'Send',
    validate: 'Validate',
    search: 'Search',
  },
  pageAboutUs: {
    intro: '<p>A TMX Mobile Solution Kft. az egyik vezető after sales szolgáltató cég Közép-Európában. Sikerünk kulcsa az elmúlt 20 év tapasztalatában, valamint a több mint 350 alkalmazottból álló, fiatal és motivált csapat erejében rejlik. Alapvető üzleti tevékenységünk a mobiltelefonok javítása, de tabletek és notebookok szervizelésével is foglalkozunk, bármilyen típusú és szintű problémáról legyen is szó. Teljes körű after sales logisztikai megoldásokat kínálunk integrált rendszereinken keresztül a mobilszolgáltatók és viszonteladók részére Magyarországon, valamint a környező országokban.</p>'
      + '<!--p>Ezen felül a TMX a Samsung európai javítási központja, 2010 óta javítunk osztrák készülékeket, továbbá 2012 óta felelősek vagyunk a Huawei mobiltelefonok, mobil stickek és modemek javításáért. 2014 óta hivatalos after-sales partnere vagyunk a Lenovo Magyarországnak.</p-->'
      + '<p>3500 négyzetméteres szervizközpontunk Budaörsön található, a javításokat teljes ESD védelemmel ellátott, és a legmodernebb eszközökkel felszerelt munkakörnyezetben végezzük. Technikusaink 200 munkaállomáson közel 1500 hibás készüléket javítanak meg naponta.</p>',
    companyHistory: 'Cégtörténet',
    companyHistoryText: '<p>Az 1997-ben, Telemax néven alapított Kft. elsődleges profilja a mobiltelefonok javítása. A Telemax 2013-ig a Műszertechnika részeként Telemax GSM Szerviz Kft. néven üzemelt, ez időpont után pedig a TMX mint jogutód már önálló vállalkozásként folytatta a működését. A vállalat életében a következő jelentős változás 2018 nyarán következett be, amikor a cseh-amerikai hátterű ARX Equity Partners nevű pénzügyi befektető cég 70%-os részesedést vásárolt a vállalkozásban. A TMX menedzsmentje azóta is változatlan formában folytatja a cég irányítását.</p>'
      + '<!--p>Működésünk 95%-a budaörsi székhelyén zajlik, az ennek teret adó 3.500 m2-es épület szintén a menedzsment tulajdona. Elsődleges üzleti tevékenységünk a mobilkészülékek és laptopok javítása, ami mellett egyéb after-sales szolgáltatásokat nyújtunk ügyfeleinknek, úgy mint: meghibásodott készülékek logisztikája, biztosított készülékek ügyintézése, eladást megelőzően mobilkészülékeken végzett átmunkálás, flottamenedzsment, személyes és telefonos ügyfélszolgálat, informatikai megoldások fejlesztése és üzemeltetése</p>'
      + '<p>A kapacitásából, javítási minőségéből és elhelyezkedéséből kifolyólag Magyarországon a legnagyobb piacrészesedéssel rendelkezünk, ebben a cégméretben egyedüli szereplője vagyunk a lokális piacnak. A közép-európai régióban szintén a vezető after-sales szolgáltatók között tartják cégünket számon, nagy volumenű tendereken indultunk és nyertünk az elmúlt években. Kiváló megítélésünket az évtizedes magasszintű szolgáltatásunknak köszönhetjük. Progresszív növekedést tudunk felmutatni az elmúlt években az elvégzett munkák mennyisége és az árbevétel szempontjából is.</p-->',
    whereAreWeNow: 'Hol tartunk most?',
    whereAreWeNowText: '<p>Partnereink közt tudhatjuk az ország mindhárom nagy mobilszolgáltatóját, továbbá mobileszköz gyártó világcégeket, készülékforgalmazókat, kiskereskedelmi vállalatokat, biztosító cégeket és – nem utolsó sorban – egyéni ügyfeleket is. Működési területünk nem az országhatárig tart: osztrák, német és szlovén partnereinkre különösen büszkék vagyunk. A TMX szlovén leányvállalata 2016 óta szolgálja ki a Telekom Slovenije biztosítással rendelkező ügyfeleit.</p>'
      + '<p>TMX a kizárólagos logisztikai after sales partnere a Vodafone-nak és Yettelnek. Minden Vodafone bolt a TMX által fejlesztett adminisztrációs rendszert használja a javítások megrendelésre és visszakövetésére.</p>'
      + '<p>Napi szinten 170 Vodafone, 140 Telenor, 50 UPC és 200 viszonteladói pontról gyűjti be a készülékeket például a Tescotól, az Euronics-től és a Mediamarkttól. Továbbá a környező országokból is gyűjtünk be készülékeket: több éves tapasztalattal rendelkezünk az Európa teljes területére kiterjedő logisztikában.</p>',
    ourFuture: 'Jövőképünk',
    ourFutureText: '<p>A magánszemélyek és a cégek esetébe egyaránt igaz, hogy a felhasználók egyre inkább mobiltelefonjukon vagy táblagépükön szervezik életüket, azokon kommunikálnak egymással. A levelezést, az üzenetváltást, az internethasználatot, sőt, a vállalati rendszerek jelentős részét is össze lehet kapcsolni a telefonnal. A mobilalkalmazások használata is egyre elterjedtebb.</p>'
      + '<p>Célunk, hogy rugalmas, pontos logisztikával és gyors, szakszerű javítással olyan szervizszolgáltatást kínáljunk ügyfeleinknek, ami gondoskodik arról, hogy a lehető legkisebb mértékben kelljen szembesülniük a meghibásodásból fakadó kellemetlenségekkel a mindennapi életükben.</p>',
    moreEmployees: 'Több mint 350 munkatárs',
    moreEmployeesText: '<p>Magyarország vezető telekommunikációs szervizeként több mint 350 munkatársunkért tartozunk felelősséggel. Mindig olyan kollégákat keresünk, akik szakterületükön kiemelkedő teljesítményt képesek nyújtani, megbízhatóak, lojálisak, lendületesek és elhivatottak. Cserébe stabil, hosszútávra szóló lehetőséget, színvonalas munkakörnyezetet és folyamatos szakmai továbbképzést biztosítunk számukra.</p>',
    whatWeAreProudOf: 'Minőség és környezettudatosság',
  },
  proudBox: {
    ISO27001Desc: 'Szolgáltatásunk mindenben megfelel az információbiztonsággal kapcsolatos szabvány szigorú követelményrendszerének.',
    ISO9001Desc: 'Cégünk teljes mértékben megfelel az ISO 9001-es szabvány minőségirányítási követelményeinek.',
    ISO14001Desc: 'Vállalatunk megfelel az ISO 14001/2015 szabványnak, mely a megfelelő környezetközpontú irányítási rendszer alapja.',
    bloodDonation: 'Céges véradás',
    bloodDonationDesc: 'Az utóbbi években rendszeressé vált cégünknél a munkahelyi véradás, mellyel aktívan hozzájárulunk a Magyar Vöröskereszt életmentő munkájához.',
    wasteSorting: 'Szelektív hulladékgyűjtés',
    wasteSortingDesc: 'Nem érjük be annyival, hogy szelektíven gyűjtjük a szemetet: az újrahasznosítható hulladékot munkánk során felhasználjuk.',
    qualityAndEnvironmentalPolicy: 'Minőség- és környezetpolitikai nyilatkozatunk',
    qualityAndEnvironmentalPolicyDesc: 'A TMX Mobile Solution Szerviz Kft. szolgáltatási tevékenységével folyamatosan törekszik megrendelőit az előírásoknak és az elvárásoknak megfelelően, magas minőségi színvonalú és környezetkímélő szolgáltatásokkal kiszolgálni, ezzel biztosítva és erősítve a TMX Mobile Solution Szerviz Kft. jó piaci helyzetét.',
  },
  pageServices: {
    intro: '<p>Komplex after sales és IT szolgáltatást nyújtunk a telekommunikációs és IT piac szereplőinek. Cégünk Közép-Európa legdinamikusabban fejlődő szervize: Magyarországon kívül jelen vagyunk Németországban, Ausztriában és Szlovéniában is. Partnereinkkel átfogó egyeztetést követően találjuk meg azt a személyre szabott szolgáltatási csomagot, mely teljes körű megoldást kínál egyedi igényeikre. Az adott cég működési profiljának megfelelő szakmai csapatot állítunk össze, amivel mind az implementáció, mind pedig az operatív együttműködés dedikált személyeken keresztül alakítható ki, ezzel biztosítva az eredményes és hosszú távú közös munka sikerét. A megoldásainkat négy fő kategóriából alakítjuk ki az optimális szolgáltatási csomag érdekében.</p>',
    servicedBrands: 'Szervizelt márkák',
    servicedBrandsText: '<p class="text-center">A választott márkára kattintva bővebb információhoz juthat az elérhető szolgáltatásokról.</p>',
    complexSolutions: 'Komplex megoldások egy kézből',
  },
  serviceBox: {
    logistics: 'Logisztika',
    logisticsDesc: 'A TMX-nél teljes körű after sales logisztikai szolgáltatásokat nyújtunk ügyfeleinknek. Az integrált nyomkövető rendszerrel megbízóink folyamatosan nyomon követhetik a készülék útját.',
    preSales: 'Pre-sales',
    preSalesDesc: 'Cégünk speciális pre-sales szolgáltatásokat is kínál az ügyfeleinek: szoftver/dashboard frissítés,  újracsomagolás, átfogó rework, átmunkálási tevékenységek.',
    networkManagement: 'Hálózatmenedzsment',
    networkManagementDesc: 'Magyarországon 17 db szerviz-átvételi és javító pontot üzemeltetünk, melyek átvételi pontként működnek, vagy akár gyors és helyi javítást is nyújthatnak az ügyfeleknek. ',
    repair: 'Javítás',
    repairDesc: 'Cégünk fő profilja az okostelefonok javítása. Emellett tabletek, laptopok és egyéb okos eszközök javításával is foglalkozunk.',
  },
  whyUs: {
    quickRepair: 'Gyors javítás',
    quickRepairDesc: 'Rövid átfutási idővel, garantált minőséggel.',
    highQuality: 'Magas minőség',
    highQualityDesc: 'A javítás elvégzése után minden készülék szigorú tesztfolyamaton esik át.',
    nationwideNetwork: 'Országos lefedettség',
    nationwideNetworkDesc: 'Ügyfeleink leadhatják a meghibásodott eszközeiket a cégünk által üzemeltetett szervizpontokon továbbá a partnerhálózatunk meghatározott pontjain.',
    customerOrientation: 'Ügyfélközpontúság',
    customerOrientationDesc: 'Legfőbb célunk ügyfeleink és partnereink igényeinek legmagasabb szintű kiszolgálása, valamint elégedettségük fenntartása.',
    friendlyAtmosphere: 'Barátságos légkör',
    friendlyAtmosphereDesc: 'Fontosnak tarjuk a kellemes, családias hangulat fenntartását kollégáink körében.',
  },
  pagePartners: {
    intro: '<p>Cégünk számos gyártó hivatalos magyarországi szervizpartnere: Alcatel, Alterco (MyKi), ASUS, Blackberry, Blaupunkt, Boway, Bullitt Group (CAT, Land Rover, Eastman Kodak), Evolveo, GoPro, HTC, HTM, Huawei, Lenovo, LG, MobiWire, Navon, Polaroid, Posh, Samsung, One Plus, Unitone, Xiaomi. Évek óta cégünk a magyar Samsung Electronics hivatalos szervizközpontja. Rendszeresen javítunk külföldről érkező telefonokat, például a HUAWEI Ausztria szervizpartnere is vagyunk. A javítások mellett after-sales logisztikai és IT megoldásokat is nyújtunk a közép-európai régióban – többek közt a Vodafone és a Telenor számára. Ügyfeleink elégedettségét mutatja, hogy a TMX több gyártó esetében is elnyertük a régió legjobb szervize díjat.</p>',
  },
  pageCareerGeneralInfos: {
    part1: '<p>A TMX Mobile Solution Szerviz Kft. Magyarország vezető mobilkommunikációs szervize. Több mint 350 munkavállalónkért tartozunk felelősséggel.</p>'
      + '<p class="title">Mit keresünk leendő munkatársainkban?</p>'
      + '<p>Dinamikusan fejlődő vállalatként folyamatosan szükségünk van új munkatársakra. Olyan kollégákat keresünk, akik szakterületükön kiemelkedő teljesítményt nyújtanak, megbízhatók, lojálisak, lendületesek és elhivatottak. Célunk elsősorban ügyfeleink és partnereink elégedettségének fenntartása.</p>',
    part2: '<p class="title">Amit mi kínálunk</p>'
      + '<p>Biztonságot, stabilitást nyújtunk. 1997 óta vagyunk jelen a piacon, és azóta dinamikusan fejlődő tendenciát mutatunk. Az ország vezető mobilkommunikácós szervizeként kijelenthetjük, hogy sikerünk kulcsa elsősorban dolgozóinkban rejlik, akiknek hosszútávra szóló lehetőséget és színvonalas munkakörnyezetet biztosítunk.</p>'
      + '<p>Családias légkört alakítottunk ki munkahelyünkön, amit különösen fontosnak tartunk kollégáink körében.</p>'
      + '<p>Sokszínű, változatos és izgalmas a mindennapi tevékenységünk. Ennek megfelelően számos lehetőséget kínálunk a munkavállalók részére központi szervizünkben: szerviztechnikus, szerviztechnikus támogató, tesztelő operátor, adminisztrátor (több nyelven), logisztikai adminisztrátor, raktározási- és anyagmozgató munkatárs, pénzügyi-számviteli, munkaügyi /HR munkakörökben.</p>'
      + '<p>Fontos számunkra, hogy kollégáink maximálisan felkészültek legyenek, emiatt folyamatos képzéseket biztosítunk számukra minden területen. Mottónk: „Nem tanítani, hanem képessé tenni.”</p>'
      + '<p>Munkatársaink folyamatos képzése mellett nagy hangsúlyt fektetünk az utánpótlás nevelésre is. Gyakorlati helyet biztosítunk a (többnyire) elektrotechnikai/műszerész szakágon tanulni vágyóknak, melynek segítségével tágabb és gyakorlatiasabb ismereteket szerezhetnek a szakterületükről.</p>',
    part3: '<p class="headline primary--text">Fehérgalléros munkaköreinkben</p>'
      + '<ul>'
      + '<li>A pozíció betöltéséhez szükséges végzettség és gyakorlati tapasztalat</li>'
      + '<li>Pályakezdők esetében befejezett, szakirányú tanulmányok</li>'
      + '<li>Angol nyelvtudás (pozíciótól függően)</li>'
      + '<li>Felhasználói szintű számítógépes ismeretek</li>'
      + '<li>Folyamatos tanulásra, képzésre való hajlandóság</li>'
      + '<li>Újításra és megújulásra való képesség</li>'
      + '<li>Motiváltság, nyitottság</li>'
      + '<li>Együttműködés, csapatszellem</li>'
      + '</ul>',
    part4: '<p class="headline primary--text">Kékgalléros munkaköreinkben</p>'
      + '<ul>'
      + '<li>A pozíció betöltéséhez szükséges szakképesítés és gyakorlati tapasztalat</li>'
      + '<li>Pályakezdők esetében befejezett, szakirányú tanulmányok</li>'
      + '<li>Jó kézügyesség, kitartás, pontosság</li>'
      + '<li>Folyamatos tanulásra, képzésre való hajlandóság</li>'
      + '<li>Újításra és megújulásra való képesség</li>'
      + '<li>Motiváltság, nyitottság</li>'
      + '<li>Együttműködés, csapatszellem</li>'
      + '</ul>',
    part5: '<p><b>A felsorolt elvárások általánosak és tájékoztató jellegűek.</b> Kérjük, minden álláshirdetésünkben figyelmesen olvasd el, hogy milyen speciális szakmai és nem szakmai elvárások kapcsolódnak az adott munkakörhöz.</p>'
      + '<p>Várjuk jelentkezésed!</p>',
  },
  mwc: {
    part1: '<h2 class="mb-10">Az MWC Barcelona a világ legnagyobb mobilrendezvénye, ahol legújabb innovációk és a legmodernebb technológia találkozik.</h2>'
      + '<p>A szervezők több mint 2400 vezető cég részvételére számítanak, és magas színvonalú konferenciaprogrammal várják az érdeklődőket, akik így felfedezhetik az iparág legforróbb témáit.</p>'
      + '<p>Az MWC Barcelona számtalan tanulási lehetőséget kínál: a résztvevők több tucat partner által vezetett programon, valamint GSMA szemináriumokon bővíthetik tudásukat.</p>'
      + '<p>Mindent, amit tudni kell – ma és a jövőben – az iparágról, azt itt megtalálja. Az a több mint 107 000 kulcsfontosságú döntéshozó, akik várhatóan részt vesznek a konferencián, mindent megtesznek azért, hogy bővítsék a résztvevők szakmai hálózatát, és segítsék elérni céljait.</p>'
      + '<p>További információért látogasson el az <a href="https://www.mwcbarcelona.com/" target="_blank">esemény weboldalára!</a></p>',
    part2: '<p class="title">Tisztelt Látogató!</p>'
      + '<p>Nagy örömmel és büszkeséggel értesítjük, hogy idén mi is részt veszünk korunk egyik legjelentősebb nemzetközi telekommunikációs rendezvényén.</p>'
      + '<p>Standunkat megtalálja a 7-es hall H sorának 18-as blokkjában a kiállítás teljes ideje alatt (2020 február 24-27.)</p>'
      + '<p>Találkozzunk az MWC-n. Hideg frissítővel vagy egy forró kávéval várjuk látogatásukat.</p>'
      + '<p class="body-2">TMX csapat</p>',
  },
  bookingForm: {
    meetUsAtTheEvent: 'Szívesen megismerkedne velünk a rendezvényen?',
    bookAnAppointment: 'Foglaljon időpontot! | Időpont foglalás',
    approval: 'Időpont megerősítése',
    confirmation: 'Visszaigazolás',
    fillTheForm: 'Kérjük, adja meg az adatait',
    pickDateAndTime: 'Válasszon időpontot',
    appointment: 'Időpont',
    bookingDetails: 'A foglalás adatai',
    successBooking: 'Sikeres foglalás',
    noFreeAppointment: 'Nincs több foglalható szabad időpontunk!',
  },
  inputLabels: {
    companyName: 'Cégnév',
    firstName: 'Firstname',
    middleName: 'Középső név',
    lastName: 'Lastname',
    email: 'E-mail',
    phone: 'Phone',
    name: 'Név',
    topic: 'Témakör',
    manufacturer: 'Brand',
    imei: 'Készülékazonosító (IMEI/SN)',
    imeiOnly: 'IMEI of the device',
    subject: 'Tárgy',
    message: 'Üzenet',
    field: 'Terület',
    job: 'Megpályázott pozíció',
    cv: 'Önéletrajz',
    otherDoc: 'Egyéb dokumentum',
    productType: 'Device type',
    warrantyType: 'Garancia típus',
    dateOfPurchase: 'Vásárlás dátuma',
    troubleDescription: 'Hibaleírás',
    simLock: 'Hálózati zár',
    country: 'Ország',
    postalCode: 'Postal code',
    city: 'City',
    publicPlaceName: 'Public place name',
    publicPlaceType: 'Public place type',
    streetNumber: 'House number',
    other: 'Other remark',
    invoice: 'Számla',
    preOrderDoc: 'Előrendelést visszaigazoló dokumentum',
    warrantyTicket: 'Jótállási jegy',
    damageNumber: 'Kárszám',
    accountNumber: 'Bank account number',
    ado: 'Tax Id',
  },
  inputMessages: {
    requiredField: 'Required field',
    requiredPrivacy: 'Az űrlap beküldéséhez el kell fogadnia az Adatvédelmi tájékoztatót!',
    requiredTermsAndCond: 'Az űrlap beküldéséhez el kell fogadnia az Általános Szerződési Feltételeket!',
    emailMatch: 'Valós e-mail címet adjon meg!',
    maxFileSizeRule: 'Maximális feltölthető fájlméret 5 MB!',
    maxFileSizeRuleOptional: 'Opcionális! Maximális feltölthető fájlméret 5 MB!',
    maxFileSizeRuleRequired: 'Kötelező kitölteni! Maximális feltölthető fájlméret 5 MB!',
    onlyNumbers: 'Csak számokat adjon meg!',
    optionalField: 'Opcionális',
    toFewCharacters: 'Túl kevés karaktert adott meg!',
    damageNumberNotMatch: 'A kárszám AS vagy VF karakterekkel kezdődik és utána 7 db számjegy következik.',
    startTypingPostalCode: 'Begépeléssel rá tud keresni az irányítószámra',
    startTypingCity: 'Begépeléssel rá tud keresni a városra',
    startTypingStreet: 'Begépeléssel rá tud keresni az utcára',
    noDataText: 'Nincs a keresésnek megfelelő adat',
  },
  loadingMessages: {
    INPROGRESS_BOOKING: '<p>A kiválasztott időpont foglalása folyamatban</p><p>Kérjük várjon</p>',
    INPROGRESS_CONTACT_FORM: '<p>Üzenet küldése folyamatban</p>',
  },
  successMessages: {
    SUCCESS_BOOKING: '<p><b>Foglálását rögzítettük!</b></p><p>Várjuk Önt a kiválasztott időpontban!</p>',
    SUCCESS_CONTACT_FORM: '<p>Üzenetét sikeresen megkaptuk!</p><p>Kollégánk hamarosan felveszi Önnel a kapcsolatot a megadott elérhetőségei egyikén.</p>',
    SUCCESS_CONTACT_FORM_2: '<span class="headline">Tisztelt Ügyfelünk!</span><br><br>Köszönjük megkeresését!<br>Munkatársaink hamarosan felveszik önnel a kapcsolatot.<br><br>Tisztelettel:<br>TMX Mobile Solution Szerviz Kft.',
    SUCCESS_REPAIR_FORM: '<span class="headline">Tisztelt Ügyfelünk!</span><br><br>Köszönjük megkeresését!<br>Készülék beküldésére vonatkozó tudnivalókat az űrlapon megadott e-mail címére küldjük.<br><br>Tisztelettel:<br>TMX Mobile Solution Szerviz Kft.',
  },
  errorMessages: {
    ERROR_GENERAL_FAIL: '<p class="headline">Sikertelen művelet!</p><p>A folyamat során váratlan hiba lépett fel!<br>Dolgozunk a hiba elhárításán!</p><p>Köszönjük türelmét!</p>',
    ERROR_AT_LEAST_ONE_FILE: '<p class="headline">Fájl feltöltése kötelező!</p><p>A javítási igény leadásához 1 db Számlát vagy 1 db Garancia jegyet kötelezően fel kell tölteni az űrlap megfelelő mezőjébe!</p>',
    INTERNAL_SERVER_ERROR: '<p class="headline">Szerver hiba!</p><p>A folyamat során váratlan hiba lépett fel!<br>Dolgozunk a hiba elhárításán!</p><p>Köszönjük türelmét!</p>',
  },
  selectFieldOptions: {
    generalRepairInfos: 'Általános javítási információk',
    inquiryAbout: 'Érdeklődés javításra leadott készülékekről',
    informationOnPaid: 'Fizetős javításokkal és/vagy árajánlatokkal kapcsolatos információk',
    insurance: 'Készülékbiztosítás',
    complaint: 'Reklamáció',
    other: 'Egyéb témakör',
  },
  pageStores: {
    part1: '<p class="headline text-center">Szervizpontjainkban garanciális és fizetős javításra egyaránt leadhatja készülékét, valamint lehetősége van új termékek és gyári tartozékok vásárlására is.</p>',
    huaweiDesc: 'Huawei készülékek javítása - akár egy órán belül!',
    huaweiCscAddress: '1085 Budapest, József krt. 17.',
    huaweiCscOpening: 'Hétfőtől péntekig: 9:00 - 15:00,<br>Szombat, Vasárnap: ZÁRVA',
    huaweiHillsideAddress: '1123 Budapest, Hillside Irodaház, Alkotás u. 55-61.',
    huaweiHillsideOpening: 'Hétfőtől péntekig: 9:00 - 15:00<br>Szombat, Vasárnap: ZÁRVA',
    samsungDesc: 'Samsung mobiltelefon, okos óra, tablet valamint fényképezőgép átvétele, autós kiszolgálás is!',
    samsungAddress: '2040 Budaörs, Kinizsi u. 1-3. (Tesco - Kika áruház közötti parkoló)',
    samsungOpening: 'Hétfőtől péntekig: 9:30 - 15:00<br>Szombat: ZÁRVA<br>Vasárnap: ZÁRVA',
    samsungRendkivuli: '<p class="display-2 mb-6">Samsung S-Drive</p>'
      + '<p class="headline">A rendkívüli helyzetre való tekintettel a Samsung Márkaszerviz (Budaörs, Kinizsi 1-3, Tesco parkoló) szombati napra  a nyitva tartást bizonytalan ideig felfüggesztjük 2020.03.21-én szombaton ZÁRVA lesz!</p>'
      + '<p class="headline">Hétköznap a jelenleg érvényben lévő és engedélyezett időszakban 09:30 – 15:00  között várjuk kedves ügyfeleinket!</p>'
      + '<p>Megértésüket köszönjük!</p>',
  },
  address: 'Cím',
  openingHours: 'Nyitva tartás',
  phone: 'Telefonszám',
  operator: 'Üzemeltető',
  /**
   * ..
   * ..
   * BRAND LANGUAGE VARIABLES
   * ..
   * ..
   */
  alcatel: {
    mapInfo: '<p>Meghibásodott készülékét garanciális és nem garanciális javításaira leadhatja a térképen megjelenített átvételi pontok bármelyikén.<br>'
      + '(Az átvételi ponton történő leadás esetén kérjük érdeklődjön az adott ponton.)</p>'
      + '<p>Hibás készülékét lehetősége van javításra leadni, a vásárlás helyén is.<br>'
      + '(A vásárlás helyén történő leadás esetén kérjük a leadás helyén érdeklődjön.)</p>',
    availableDesc: '<p>Gyártói ügyfélszolgálat elérhetősége: +36 (1) 429-2215</p>'
      + '<p>Gyártói weboldal: <a href="https://eu.alcatelmobile.com/hu/" target="_blank">https://eu.alcatelmobile.com/hu/</a><p>',
    unavailableDesc: '',
  },
  asus: {
    mapInfo: '<p>Meghibásodott készülékét garanciális és nem garanciális javításaira leadhatja a térképen megjelenített átvételi pontok bármelyikén.<br>'
      + '(Az átvételi ponton történő leadás esetén kérjük érdeklődjön az adott ponton.)</p>'
      + '<p>Hibás készülékét lehetősége van javításra leadni, a vásárlás helyén is.<br>'
      + '(A vásárlás helyén történő leadás esetén kérjük a leadás helyén érdeklődjön.)</p>',
    availableDesc: '<p>A fent felsorolt Asus termékek garanciális és nem garanciális javításaira, háztól-házig (pick-up and return) szolgáltatás elérhető Magyarország egész területén.</p>'
      + '<p>Pick-up and return szolgáltatás igényléséhez futárigényét az alábbi elérhetőségen tudja elindítani: <a href="https://rma.asus-europe.eu/hu" target="_blank">https://rma.asus-europe.eu/hu</a><p>'
      + '<p>További információkért kérjük látogasson el a <a href="https://www.asus.com/hu/support/" target="_blank">https://www.asus.com/hu/support/</a> oldalra.</p>',
    unavailableDesc: '<p>A fent felsorolt termékektől eltérő készülékek javításáról kérjük az alábbi elérhetőségen érdeklődjön:<br>'
      + '<a href="https://www.asus.com/hu/support/" target="_blank">https://www.asus.com/hu/support/</a><br>'
      + 'Gyártói weboldal: <a href="https://www.asus.com/hu/" target="_blank">https://www.asus.com/hu/</a></p>',
  },
  blaupunkt: {
    mapInfo: '<p>Meghibásodott készülékét garanciális és nem garanciális javításaira leadhatja a térképen megjelenített átvételi pontok bármelyikén.<br>'
      + '<i>(Az átvételi ponton történő leadás esetén kérjük érdeklődjön az adott ponton.)</i></p>'
      + '<p>Hibás készülékét lehetősége van javításra leadni, a vásárlás helyén is.<br>'
      + '<i>(A vásárlás helyén történő leadás esetén kérjük a leadás helyén érdeklődjön.)</i></p>',
    availableDesc: '',
    unavailableDesc: '',
  },
  cat: {
    mapInfo: '<p>Meghibásodott készülékét garanciális és nem garanciális javításaira leadhatja a térképen megjelenített átvételi pontok bármelyikén.<br>'
      + '<i>(Az átvételi ponton történő leadás esetén kérjük érdeklődjön az adott ponton.)</i></p>'
      + '<p>Hibás készülékét lehetősége van javításra leadni, a vásárlás helyén is.<br>'
      + '<i>(A vásárlás helyén történő leadás esetén kérjük a leadás helyén érdeklődjön.)</i></p>',
    availableDesc: '',
    unavailableDesc: '',
  },
  evolveo: {
    mapInfo: '<p>Meghibásodott készülékét garanciális és nem garanciális javításaira leadhatja a térképen megjelenített átvételi pontok bármelyikén.<br>'
      + '<i>(Az átvételi ponton történő leadás esetén kérjük érdeklődjön az adott ponton.)</i></p>'
      + '<p>Hibás készülékét lehetősége van javításra leadni, a vásárlás helyén is.<br>'
      + '<i>(A vásárlás helyén történő leadás esetén kérjük a leadás helyén érdeklődjön.)</i></p>',
    availableDesc: '',
    unavailableDesc: '',
  },
  gopro: {
    mapInfo: '<p>Hibás készülékét lehetősége van javításra leadni, a vásárlás helyén is.<br>'
      + '(A vásárlás helyén történő leadás esetén kérjük a leadás helyén érdeklődjön.)</p>'
      + '<p>Garanciális javításra elérhető háztól-házig szolgáltatás is, melyről részletes információkat az alábbi elérhetőségen talál:<br>'
      + '<a href="https://docs.google.com/forms/d/e/1FAIpQLSeCcPjkrxCz4nxZh2DhjevbDYRIPL0CqKcbdBlJ0mBinuIz7A/viewform" target="_blank">Megtekintéshez kattintson ide</a></p>',
    availableDesc: '<p>Gyártói weboldal:<br><a href="https://gopro.com" target="_blank">https://gopro.com</a></p>'
      + '<p>Egyéb információk:<br><a href="https://community.gopro.com" target="_blank">https://community.gopro.com</a></p>',
    unavailableDesc: '<p>A fent felsorolt termékektől eltérő készülékek javításáról és az általános jótállás feltételeiről, kérjük érdeklődjön a vásárlás helyén.</p>',
    prodDesc: 'Javításra leadható termékek kizárólag a Spinnaker Distribution Kft. által forgalmazott GoPro termékek.',
  },
  gsmart: {
    mapInfo: '<p>Meghibásodott készülékét garanciális és nem garanciális javításaira leadhatja a térképen megjelenített átvételi pontok bármelyikén.<br>'
      + '<i>(Az átvételi ponton történő leadás esetén kérjük érdeklődjön az adott ponton.)</i></p>'
      + '<p>Hibás készülékét lehetősége van javításra leadni, a vásárlás helyén is.<br>'
      + '<i>(A vásárlás helyén történő leadás esetén kérjük a leadás helyén érdeklődjön.)</i></p>',
    availableDesc: '',
    unavailableDesc: '',
  },
  htc: {
    mapInfo: '<p>Meghibásodott készülékét garanciális és nem garanciális javításaira leadhatja a térképen megjelenített átvételi pontok bármelyikén.<br>'
      + '<i>(Az átvételi ponton történő leadás esetén kérjük érdeklődjön az adott ponton.)</i></p>'
      + '<p>Hibás készülékét lehetősége van javításra leadni, a vásárlás helyén is.<br>'
      + '<i>(A vásárlás helyén történő leadás esetén kérjük a leadás helyén érdeklődjön.)</i></p>',
    availableDesc: '',
    unavailableDesc: '',
  },
  huawei: {
    mapInfo: '<p>Meghibásodott készülékét garanciális és nem garanciális javításaira leadhatja a térképen megjelenített átvételi pontok bármelyikén.<br>'
      + '(Az átvételi ponton történő leadás esetén kérjük érdeklődjön az adott ponton.)</p>'
      + '<p>Amennyiben a Posta ponton történő leadási lehetőséget választja, részletes információkat az alábbi elérhetőségen talál:<br>'
      + '<a href="https://consumer.huawei.com/hu/support/komfortszerviz/" target="_blank">https://consumer.huawei.com/hu/support/komfortszerviz/</a></p> '
      + '<p>Bizonyos készülékekre elérhető háztól-házig szolgáltatás is, melyről részletes információkat az alábbi elérhetőségen talál:<br>'
      + '<a href="https://consumer.huawei.com/hu/support/haztolhazig/" target="_blank">https://consumer.huawei.com/hu/support/haztolhazig/</a></p>'
      + '<p>Hibás készülékét lehetősége van javításra leadni, a vásárlás helyén.<br>'
      + '(A vásárlás helyén történő leadás esetén kérjük a leadás helyén érdeklődjön.)</p>'
      + '<p>A TMX által üzemeltetett Huawei üzleteinkben elérhető helyszíni javítás is.<br>'
      + '<i>(Bővebb információkért kérjük keresse fel a választott üzletet.)</i></p>',
    availableDesc: '',
    unavailableDesc: '<p>A fent felsorolt termékektől eltérő készülékek javításáról és az általános jótállás feltételeiről, kérjük az alábbi elehetőségen érdeklődjön:<br>'
      + '<a href="https://consumer.huawei.com/hu/support/" target="_blank">https://consumer.huawei.com/hu/support/</a><br>'
      + 'Gyártói weboldal: <a href="https://consumer.huawei.com/hu/" target="_blank">https://consumer.huawei.com/hu/</a></p>',
  },
  lenovo: {
    mapInfo: '<p>A fent felsorolt Lenovo termékek garanciális és nem garanciális javításaira, háztól-házig (pick-up and return) szolgáltatás elérhető Magyarország egész területén.<br>Pick-up and return szolgáltatás igényléséhez futárigényét elküldheti számunkra a következő email címre is: <a href="mailto:lenovo@tmx.hu">lenovo@tmx.hu</a></p>'
      + '<p>Levelére érkezni fog egy automatikus válaszüzenet, melyben minden fontos információt megtalál. Az ebben az üzenetben kért adatok megküldésével lesz igénylése aktív.</p>'
      + '<p>Garanciális javítás esetén a futárszolgálat díjmentes.</p>'
      + '<p>A javítás befejeztével az MPL futárszolgálat SMS értesítést küld a kiszállítás időpontjáról az Ön által megadott telefonszámra. Kétszeri meghiúsult kézbesítés esetén a készülék a Posta által megadott ponton átvehető 10 munkanapig.</p>'
      + '<p>Javítás alatt lévő készülékéről a leadás helyén, vagy szervizünknél érdeklődhet emailben az info@tmx.hu címen, vagy telefonon +36(23) 801-729.</p>'
      + '<p>Hibás készülékét lehetősége van javításra leadni, a vásárlás helyén is.<br>'
      + '<i>(A vásárlás helyén történő leadás esetén kérjük a leadás helyén érdeklődjön.)</i></p>',
    availableDesc: '<p>Gyártói weboldal: <a href="https://www.lenovo.com/hu/hu" target="_blank">https://www.lenovo.com/hu/hu</a></p>',
    unavailableDesc: '<p class="font-weight-bold">THINK termékek (ThinkPad, ThinkPad Tablet, ThinkCentre, ThinkStation, ThinkServer, ThinkVision)</p>'
      + '<p>A Think termékek központi és helyszíni garanciális szolgáltatásait a Lenovo THINK hivatalos szerviz partneri hálózata biztosítja (a készüléket '
      + 'ezekbe a szervizpontokba viheti be javításra). Ha szeretné, akkor a készüléket közvetlenül a kereskedőhöz is visszaviheti, aki érvényesíti Önnek '
      + 'a garanciális szolgáltatást.</p>',
  },
  lg: {
    mapInfo: '<p>Meghibásodott készülékét garanciális és nem garanciális javításaira leadhatja a térképen megjelenített átvételi pontok bármelyikén.<br>'
      + '<i>(Az átvételi ponton történő leadás esetén kérjük érdeklődjön az adott ponton.)</i></p>'
      + '<p>Hibás készülékét lehetősége van javításra leadni, a vásárlás helyén is.<br>'
      + '<i>(A vásárlás helyén történő leadás esetén kérjük a leadás helyén érdeklődjön.)</i></p>',
    availableDesc: '',
    unavailableDesc: '<p>A fent felsorolt termékektől eltérő készülékek javításáról kérjük az alábbi elehetőségen érdeklődjön:<br>'
      + '<a href="https://www.lg.com/hu/tamogatas/javitas-garancia/szerviz-kereses" target="_blank">https://www.lg.com/hu/</a>',
  },
  samsung: {
    mapInfo: '<p>Meghibásodott készülékét garanciális és nem garanciális javításaira leadhatja a térképen megjelenített átvételi pontok bármelyikén.<br>'
      + '<i>(Az átvételi ponton történő leadás esetén kérjük érdeklődjön az adott ponton.)</i></p>'
      + '<p>Amennyiben a Samsung Posta ponton történő leadási lehetőséget választja, részletes információkat az alábbi elérhetőségen talál:<br>'
      + '<a href="https://www.samsung.com/hu/support/postapont-szerviz/" target="_blank">https://www.samsung.com/hu/support/postapont-szerviz/</a></p>'
      + '<p>Hibás készülékét lehetősége van javításra leadni, a vásárlás helyén is.<br>'
      + '<i>(A vásárlás helyén történő leadás esetén kérjük a leadás helyén érdeklődjön.)</i></p>'
      + '<p>A Samsung MSC pontokon elérhető helyszíni javítási lehetőség is.<br>'
      + '<i>(További információért kérjük keresse fel a választott MSC pontot.)</i></p>',
    availableDesc: '',
    unavailableDesc: '<p>A fent felsorolt termékektől eltérő készülékek javításáról és az általános jótállás feltételeiről, kérjük az alábbi elehetőségen érdeklődjön:<br><a href="https://www.samsung.com/hu/support/warranty/" target="_blank">https://www.samsung.com/hu/support/warranty/</a></p>'
      + '<p>Gyártói támogatás:<br><a href="https://www.samsung.com/hu/business/contactus/" target="_blank">https://www.samsung.com/hu/business/contactus/</a></p>'
      + '<p>Gyártói weboldal:<br><a href="https://www.samsung.com/hu/" target="_blank">https://www.samsung.com/hu/</a></p>',
  },
  xiaomi: {
    mapInfo: '<p>Meghibásodott készülékét garanciális és nem garanciális javításaira leadhatja a térképen megjelenített átvételi pontok bármelyikén.<br>'
      + '<i>(Az átvételi ponton történő leadás esetén kérjük érdeklődjön az adott ponton.)</i></p>'
      + '<p>Hibás készülékét lehetősége van javításra leadni, a vásárlás helyén is.<br>'
      + '<i>(A vásárlás helyén történő leadás esetén kérjük a leadás helyén érdeklődjön.)</i></p>',
    availableDesc: '',
    unavailableDesc: '<p>A fent felsorolt termékektől eltérő készülékek javításáról és az általános jótállás feltételeiről, kérjük érdeklődjön a vásárlás helyén.</p>'
      + '<p>Gyártói weboldal:<br><a href="https://www.mi.com/global" target="_blank">https://www.mi.com/global</a></p>',
    ecoDesc: 'Kizárólag a Mystical Hungary Kft. által forgalmazott termékek',
  },
  products: {
    cellphones: 'Mobiltelefonok',
    tablets: 'Táblagépek',
    watches: 'Okosórák',
    watchesAndBands: 'Okosórák, Okos karkötők',
    smartDevices: 'Okoseszközök',
    notebooks: 'Notebookok',
    actionCams: 'Akciókamerák',
    otherAccess: 'Külön vásárolható tartozékok',
    network: 'Hálózati eszközök',
    cellphoneAccess: 'Mobiltelefon tartozékok',
    freeBuds: 'Freebuds 3',
    ideaNotebooks: 'IDEA Notebookok',
    ideaTablets: 'IDEA Tabletek',
    ideaMonitorAndVr: 'IDEA Monitorok és AR/VR eszközök',
    ideaDesktop: 'IDEA Desktop',
    ideaAllInOne: 'IDEA All in one',
    ecoProducts: 'ECO Products',
    gear: 'Gear okosórák, okos karkötők',
    gearStuffs: 'Gear VR, Gear 360, IconX, Buds',
    cameras: 'Fényképezőgépek',
  },
  pageBrand: {
    productsForRepair: 'Javításra leadható termékek',
    productsNotRepair: 'Javításra nem leadható termékek',
    repairServiceAndPickupOpportunities: 'Szervizszolgáltatás és átvételi lehetőségek',
    pickupLocations: 'Átvevő pontok országszerte',
    repairInformationsAndManufacturersContact: 'Javítási információk, gyártói elérhetőségek',
  },
  loremIpsumPar: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vitae dapibus odio. Donec posuere nulla felis, eget posuere ligula posuere sit amet. Duis commodo at dolor eu iaculis. Nunc tempus felis non lectus porta pulvinar. Suspendisse at fermentum magna. Quisque dictum, enim id blandit porttitor, felis erat elementum augue, et dapibus nunc ex sed velit. Integer metus leo, blandit sed sapien sed, euismod laoreet odio.</p>'
    + '<p>Vivamus volutpat ultrices felis quis suscipit. Morbi mollis molestie lorem vitae tincidunt. Donec blandit ante sed lobortis laoreet. Phasellus venenatis dui justo, ac pulvinar elit porttitor vel.</p>',
  warranties: {
    warrantyRepair: 'Garanciális javtás',
    noWarrantyRepair: 'Fizetős javtás',
  },
  repairBoxes: {
    warrantyRepair: 'Garanciális javítás',
    warrantyRepairDesc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vitae dapibus odio. Donec posuere nulla felis, eget posuere.',
    payedRepair: 'Fizetős javítás',
    payedRepairDesc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vitae dapibus odio. Donec posuere nulla felis, eget posuere.',
    needHelpRepair: 'Nem tudom eldönteni',
    needHelpRepairDesc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vitae dapibus odio. Donec posuere nulla felis, eget posuere.',
    insuranceRepair: 'Biztosítás javítás',
    insuranceRepairDesc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vitae dapibus odio. Donec posuere nulla felis, eget posuere.',
  },
  serviceRepairText: '<p>Tisztelt Ügyfelünk!</p>'
    + '<p>Kérjük válasszon az alábbi két lehetőség közül, majd adja meg a kért adatokat, hogy futárszolgálatunk be tudja gyűjteni a szervizelendő készülékét.</p>'
    + '<p>Amennyiben Apple készüléket szeretne beküldeni kérjük az FMI (Find My iPhone) funkciót kapcsolja ki mielőtt átadja a futárnak a terméket. Szervizünk addig nem tudja a javítást megkezdni, amíg ez a funkció aktív.</p>'
    + '<p>Tájékoztatjuk, hogy gyártói előírások értelmében, amennyiben mechanikai sérülés okozta a készülék hibáját (pl: vízbe esett, leesett, betört a kijelző, sérült a burkolat, stb), ezt jótállási keret között nem tudjuk javítani, kérjük ilyen esetben lenti két opcióból válassza a Fizetős javítást.</p>'
    + '<p>A jótállási keretein belül történő javítás esetén, kérjük küldje be készüléke mellett az érvényes jótállási jegyet és/vagy a számla másolatát.</p>'
    + '<p>Amennyiben bármi kérdése lenne, kérjük írjon nekünk az info@tmx.hu e-mail címre, vagy hívjon minket a <a href="tel:+3615858381" class="body-1">+36-1/58-58-381</a> telefonszámon.</p>'
    + '<p></p>'
    + '<p></p>'
    + '<p>TMX Mobile Solution Szerviz Kft.</p>',
  storeOpeningCovidText: '<p class="display-2 mb-6">Rendkívüli nyitva tartás!</p>'
    + '<p class="headline">Tájékoztatjuk, hogy a Kormány 2020.03.16.-án kihirdetett a Koronavírus visszaszorítása iránti intézkedése értelmében 2020.03.17.-től bizonytalan ideig üzleteink  15:00-ig tartanak nyitva!</p>'
    + '<p>Megértésüket köszönjük!</p>',
  infoPopup: {
    title: 'Nyugodtan otthon maradhatsz, mi házhoz megyünk készülékedért!',
    content1: 'Vedd igénybe díjmentes háztól házig szolgáltatásunkat, kattints a ',
    content2: 'menüpontra.',
    hashTags: '#tmxfamily #keepcalm #maradjotthon',
  },
  imeiHint: 'You can enquire by entering the code *#06#',
  checkSpamFolder: 'Sikeres igény mentése esetén az űrlapon megadott e-mail címre visszajelzést küldünk. Ellenőrizze a SPAM mappát is a postafiókjában!',
  moreInfosAboutTheService: 'Tájékoztatás a szolgáltatásról',
  imeiError: 'Az Ön által megadott egyedi azonosító nem felel meg a Luhn-algoritmusnak, kérjük ellenőrizze, hogy megfelelően adta-e meg az adatot. Amennyiben Ön gyári számot adott meg, kérjük tekintse tárgytalannak az üzenetet.',
  attachDocs: 'Csatolja be a dokumentumokat, ha nem tudja beküldeni a készülékkel.',
  /**
   * TRADE-IN
   */
  searchBasedOnImei: 'Search by IMEI',
  buybackDevice: 'Device to be sold',
  brands: 'Gyártók',
  lastBuybackedDevices: 'Legutoljára beérkezett készülékek',
  promoSzoveg: '<div class="display-2" style="line-height: 2;"><b>Készüléked megvesszük,</b></div>'
    + '<div class="headline">a környezettudatosság és újrahasznosítás zászlaja alatt javítjuk, majd kereskedői partnereinkhez juttatjuk.</div>',
  personalInformations: 'Personal data',
  shippingInformations: 'Delivery details',
  // eslint-disable-next-line max-len
  orderDisclaimer: 'Based on the information you provide, we will send you an indicative purchase price for your device, '
    + 'based on the conditions you have set. If you are satisfied with the offer, our courier will pick up the device, so '
    + 'that our technicians can examine it and make a final offer, which will be transferred if accepted, or returned if not.',
  // eslint-disable-next-line max-len
  shippingDisclaimer: 'Based on your shipping information, our MPL courier will pick up your device at a pre-arranged time '
    + 'so that our technician can review your condition information after shipping. We will then send you a final offer, '
    + 'which will be transferred if accepted, or returned if not!',
  yourDevice: 'Az ön készüléke',
  stepper: {
    calculate: 'KALKULÁLJ',
    sendYourDevice: 'KÜLDD BE KÉSZÜLÉKED',
    sendFree: 'KÜLDJE BE INGYENESEN',
    examFree: 'BEVIZSGÁLJUK AJÁNLATOT ADUNK',
    acceptOffer: 'AJÁNLAT ELFOGADÁS',
    transferMoney: 'UTALJUK A VÉTELÁRAT',
  },
  sellYourDeviceWithTmxBBSzoveg: '<div class="display-1 mb-6"><b>Add el használt készüléked a TMX BuyBack segítségével!</b></div>'
    + '<div class="headline">Biztonságos és kényelmes!</div>',
  safeAndComfortable: 'Biztonságos és kényelmes!',
  sellYourDeviceWithTmxBB: 'Add el használt készüléked a TMX BuyBack segítségével!',
  information: {
    first: {
      title: 'Használt, de nem haszontalan',
      desc: 'Ha meguntad régi, nem használt készüléked, vagy csak új készüléket vásárolnál és csökkentenéd költségeidet, mi rendelkezésedre állunk a lehető legkényelmesebb mobilbarát folyamattal.'
    },
    second: {
      title: 'Kényelmes és gyors',
      desc: 'A készüléked állapotának megadásával már el is tudod kezdeni a beküldés folyamatát!<br>'
        + 'Adataid megadása után futárunk elmegy a készülékedért, hogy nálunk bevizsgálásra kerüljön és megadjuk ajánlatunkat.',
    },
    third: {
      title: 'Precíz',
      desc: 'Profi szakembereink segítségével precíz ajánlatot szolgáltatunk részedre, amelyet el tudsz fogadni, vagy utasítani. Elutasítás esetén semmi tennivalód nincs a logisztikai költségek megtérítésén kívül, futárszolgálat segítségével visszajuttatjuk neked a készüléked.',
    }
  },
  faq: {
    faq1: {
      q: 'Mennyi ideig tart még megkapom a készülékem árát? ',
      a: 'Az előzetes ajánlattételtől számított két héten belül megtörténik az utalás és lezárul az adásvétel, amennyiben elfogadod az árajánlatot.',
    },
    faq2: {
      q: 'Honnan tudom, hogy hibás az akkumulátorom?',
      a: 'A legtöbb mai akkumulátor lítium-ionos, amely az elhasználódás utolsó fázisaiban gázt termelnek. Egy bizonyos idő után a vékony akkumulátor borítás felpúposodik, amely komoly problémákkal járhat, mint például a gyorsabb lemerülés, forrósodás.',
    },
    faq3: {
      q: 'Hálózatfüggő készüléket is beszámíthatok? ',
      a: 'Igen, nem akadálya az adásvételnek a hálózati zár megléte.',
    },
    faq4: {
      q: 'Milyen típusú készüléket tudok beszámítani?',
      a: 'A katalógusban szereplő gyártók listájából kiválasztható típusait tudjuk megvásárolni. Amennyiben a listában vagy a keresőben nem találod meg a készüléked típusát, úgy azt nem áll módunkban megvásárolni.',
    },
    faq5: {
      q: 'Beázott a készülékem, így is megvásárolják?',
      a: 'Sokszor látott hiba,  mivel ez a hiba az esetek többségében javítható, vagy ha mégsem, akkor az eszköz többi része még használható, ezért ezeket a telefonokat is el tudja nálunk adni!',
    },
    faq6: {
      q: 'Ha iPhone-om van, inaktívra kell állítanom a „készülék keresése” (find my iphone) funkciót?',
      a: 'Igen, amennyiben aktív az FMI funkció, nem tudjuk megvásárolni a készüléket, itt találsz  bővebb információt ennek eltávolításáról.',
    },
    faq7: {
      q: 'Mit kell beküldenem a készülékemmel (tartozékok, díszdoboz)?',
      a: 'Mind az előzetes, mind a végleges árajánlatunk kizárólag a készülékre vonatkozik. Az árajánlatok végösszegét nem befolyásolja a tartozékok, vagy a gyári doboz megléte.',
    },
    faq8: {
      q: 'Az IMEI szám beírása után a rendszer nem ismeri fel a készülékemet.',
      a: 'Ebben az esetben sajnos nincs lehetősége használt eszköze eladására.',
    },
    faq9: {
      q: 'Adatokat töröljük a készülékről?',
      a: 'Igen, minden esetben töröljük a készülék teljes memóriáját.',
    },
    faq10: {
      q: 'Véletlen a készlékben maradt a SIM kártya és/vagy SD kártya. Vissza lehet kérni?',
      a: 'Sajnos erre nincs lehetőség.',
    },
    faq11: {
      q: 'A szállításhoz szükséges információk',
      a: '<ol>'
        + '<li>Távolítsd el a szállítóládát lezáró plombát és nyitást követően a következőket találod a szállítóládában (2 db vízhatlan zacskó, 2 db plomba, 1 db visszaszállítási címirat, öntapadó fóliatasak)</li>'
        + '<li>Vedd ki mindet a szállítóládából</li>'
        + '<li>Helyezd a készüléked a vízhatlan zacskóba, a másik vízhatlan zacskóba pedig, az eladáshoz szükséges tartozékokat (akkumulátor, töltő).</li>'
        + '<li>Ezt követően zárd le a 2 db vízhatlan zacskót és tedd bele a szállítóládába!</li>'
        + '<li>A 2 db plomba segítségével - a kézbesítő jelenlétében zárd le a ládát!</li>'
        + '<li>A visszaszállítási címirat ügyfélpéldányát a kézbesítő aláírja, azt őrizd meg, ez igazolja a csomag visszaküldését!</li>'
        + '<li>A visszaszállítási címirat postai példányát helyezd az öntapadós fóliatasakba és ragaszd a szállítóláda tetejére.</li>'
        + '</ol>',
    },
  },
  screen: 'Kijelző',
  battery: 'Akkumulátor',
  cover: 'Hátlap/Keret',
  deviceStatus: 'Condition of the device',
  networkLock: 'Hálózati zár',
  noDataText: {
    productGroups: 'A kiválasztott gyártóhoz nincs Termék csoport!',
    general: 'Nincs megjeleníthető adat.',
    noRequestFound: 'Nem található leadott igény',
    noSearchResult1: 'A keresett ',
    noSearchResult2: 'kifejezés nem található ',
  },
};
